exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity0[data-v-6c40459a]{opacity:0}.wrapper-name[data-v-6c40459a]{display:flex;white-space:nowrap}.wrapper-name .name[data-v-6c40459a]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
